// Angular imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';

// Rxjs imports
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// Constant imports
import { URLConstants } from '../../../../_constants/url-constants';

// Model imports
import { GLBatchDetailParametersDto } from '../../_models/general-ledger/gl-batch/gl-batch-detail-parameters-dto';
import { GLBatchDetailResultDto } from '../../_models/general-ledger/gl-batch/gl-batch-detail-result-dto';
import { GLBatchSummaryParametersDto } from '../../_models/general-ledger/gl-batch/gl-batch-summary-parameters-dto';
import { GLBatchSummaryResultDto } from '../../_models/general-ledger/gl-batch/gl-batch-summary-result-dto';

@Injectable({
    providedIn: 'root'
})
export class GLBatchService {
    constructor(private readonly httpClient: HttpClient) {}

    getGLBatchSummary(params: GLBatchSummaryParametersDto): Observable<GLBatchSummaryResultDto> {
        const url = `${URLConstants.ccCBGLBatchApiUrl}/summary`;
        return this.httpClient
            .post(url, classToPlain(params))
            .pipe(map((response: any) => plainToClass(GLBatchSummaryResultDto, response)));
    }

    getGLBatchDetail(params: GLBatchDetailParametersDto): Observable<GLBatchDetailResultDto> {
        const url = `${URLConstants.ccCBGLBatchApiUrl}/detail`;
        return this.httpClient
            .post(url, classToPlain(params))
            .pipe(map((response: any) => plainToClass(GLBatchDetailResultDto, response)));
    }
}
